'use client'

import { FrontendConfig } from '@repo/shared/types/frontend-config.types'
import { createContext, useContext } from 'react'

const ConfigContext = createContext<FrontendConfig>({
  reserveAppointmentLockInSeconds: 120,
})

export const ConfigProvider = ({
  config,
  children,
}: React.PropsWithChildren<{ config: FrontendConfig }>) => {
  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>
}

export const useConfig = () => {
  const content = useContext(ConfigContext)
  if (!content) {
    throw new Error('useConfig must be used within a ConfigProvider')
  }
  return content
}
